import { framework } from '@buzzfeed/consent';

const CONSENT_PATHNAMES = ['/', '/discover', '/content-objects/[contentType]/[id]'];

export const showConsentOnPage = (pathname) => CONSENT_PATHNAMES.includes(pathname);
